import React, { Fragment } from 'react';
import withTranslations from '../../utils/HighOrderComponent';
import { Col, Row } from 'react-bootstrap';
import ButtonsDemo from '../Demo/ButtonsDemo';
import PopupDemo from '../Demo/PopupDemo';
import TabsDemo from '../Demo/TabsDemo';
import BreadcrumbsDemo from '../Demo/BreadcrumbsDemo';
import AlertDemo from '../Demo/AlertsDemo';
import OtherReferenceList from '../Demo/OtherReferenceList';
import ChipDemo from '../Demo/ChipDemo';
import FormExample from '../Demo/FormExample';
import FieldsDemoContainer from '../Demo/FieldsDemoContainer';

const ComponentDemo = (props) => {
  const { gt } = props || {};

  return (
    <Fragment>
      <Row>
        <Col md={8} className="p-0">
          <ButtonsDemo />
          <AlertDemo />
          <PopupDemo gt={gt} />
          <TabsDemo />
          <BreadcrumbsDemo />
          <ChipDemo />
        </Col>
        <Col md={4}>
          <FieldsDemoContainer />
        </Col>
        <Col md={12}>
          <FormExample />
        </Col>
      </Row>
      <Row>
        <OtherReferenceList />
      </Row>
    </Fragment>
  );
};

export default withTranslations(ComponentDemo);
